import { FormControl, TextField, MenuItem, InputLabel, Select, Button, Autocomplete, Snackbar, Alert, Stack } from '@mui/material'
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import React, { useEffect, useRef, useState } from 'react'
import TPCheckbox from "../../TemplateProperties/TPCheckbox";
import { authenticationWebServiceDestinationTypeOptions, authenticationWebServiceSourceTypeOptions } from '../../../constants/constantList';
import { debounce } from 'lodash';
import { useTranslation } from 'react-i18next';

import { stringifyJSONAttributes, stringToBooleanConversion } from '../../../utils/utilFunctions';
import { api } from '../../../redux/api';
import { useDispatch, useSelector } from 'react-redux';
import SmartPasswordField from '../../../commonComponents/SmartPasswordField';
import ErrorModal from '../../ItemProperties/Forms/FieldDataValidation/ErrorModal';

const WebService = ({ connectionDetails, handleBodyContent, direction, account }) => {
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.queryParams);
    const fileBrowser = useRef();
    const dispatch = useDispatch();
    const [useWSDL, setUseWSDL] = useState(false);
    const [wsdlFile, setWsdlFile] = useState('');
    const [filePath, setFilePath] = useState('');
    const [oldUrl, setOldUrl] = useState("");
    const [recallRefresh, setRecallRefresh] = useState(false);
    const [wsdlCombo, setWsdlCombo] = useState({});
    const [serviceEndpoint, setServiceEndpoint] = useState('');
    const [targetNameSpace, setTargetNameSpace] = useState('');
    const [requestElement, setRequestElement] = useState('');
    const [soapAction, setSoapAction] = useState('');
    const [soapPrefix, setSoapPrefix] = useState('');
    const [authentication, setAuthentication] = useState('NONE');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [realm, setRealm] = useState('');
    const [outTime, setOutTime] = useState('');
    const [privateKeys, setPrivateKeys] = useState([]);
    const [privateKey, setPrivateKey] = useState('');
    const [sslVersion, setSslVersion] = useState('');
    const [soapAsBody, setSoapAsBody] = useState(false);
    const [httpSession, setHttpSession] = useState(false);
    const [policy, setPolicy] = useState('');
    const [keyStore, setKeyStore] = useState('');
    const [keyStorePassword, setKeyStorePassword] = useState('');
    const [keyType, setKeyType] = useState('');
    const [privateKeyPassword, setPrivateKeyPassword] = useState('');
    const [userCertAliasTypes, setUserCertAliasTypes] = useState([]);
    const [userCert, setUserCert] = useState('');
    const [syncResponse, setSyncResponse] = useState(false);
    const [soapBody, setSoapBody] = useState(false);
    const [checkDataTransfer, setCheckDataTransfer] = useState(false);
    const [sslVersionsTypeOptions, setSslVersionsTypeOptions] = useState([]);
    const [content, setContent] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [bindingOptions, setBindingOptions] = useState([
      {
        text: t("EMPTY_COMBO"),
        value: t("EMPTY_COMBO"),
      },
    ]);
    const [operationOptions, setOperationOptions] = useState([
      {
        text: t("EMPTY_COMBO"),
        value: t("EMPTY_COMBO"),
      },
    ]);
    const [servicePortOptions, setServicePortOptions] = useState([
      {
        text: t("EMPTY_COMBO"),
        value: t("EMPTY_COMBO"),
      },
    ]);

    const [wsdlFields, setWsdlFields] = useState({
      wsdlPath: "",
      binding: bindingOptions[0]?.value,
      operation: operationOptions[0]?.value,
      servicePort: servicePortOptions[0]?.value,
    });

    const [showAlert, setShowAlert] = useState({ mssg: '', type: 'success', isOpen: false });

    const handleAlertClose = () => {
        setShowAlert({ ...showAlert, isOpen: false });
    }

    const debouncedContentUpdate = debounce(handleBodyContent, 500);

    const onInputChange = (name, value, bulk) => {
        if (bulk)
          setContent((prev) => {
            return { ...prev, ...bulk };
          });
        else
          setContent((prev) => {
            return { ...prev, [name]: value };
          });
    }

    function getWsDlCombos(url, cache, oldUrl, refresh = false) {
      setRecallRefresh(refresh);
      const sendCache = url === oldUrl ? cache : "";
      dispatch(
        api.endpoints.getWsdlCombos.initiate(
          {
            user,
            account,
            fileUrl: encodeURIComponent(url),
            wsdl_cache: encodeURIComponent(sendCache),
            old_path: encodeURIComponent(oldUrl),
            refresh,
          },
          { forceRefetch: true }
        )
      )
        .then((res) => {
          if (res?.data?.data?.hasOwnProperty("error") || res?.data?.current_state === "ERROR") {
            setWsdlFields((prev) => ({
              ...prev,
              wsdlPath: oldUrl,
            }));
            onInputChange("WSDL_PATH", oldUrl);
            setShowErrorModal(true);
            setErrorMessage(url);
          } else {
            setWsdlCombo(res?.data?.data);
            setOldUrl(url);
          }
        })
        .catch(() => {
          setWsdlFields((prev) => ({
            ...prev,
            wsdlPath: oldUrl,
          }));
          onInputChange({ WSDL_PATH: oldUrl });
        });
    }
    function handleOperationChange(e) {
        const operation = e.target.value;
    
        setWsdlFields({ ...wsdlFields, operation: e.target.value });
    
        const updateObj = { [e.target.name]: e.target.value };
        if (operation === t("EMPTY_COMBO") || operation === t("SELECT")) {
          updateObj["REQUEST_ELEMENT_NAME"] = null;
          updateObj["SOAP_ACTION"] = null;
    
          setRequestElement("");
          setSoapAction("");
        } else {
          const operationData = wsdlCombo?.soapBindings?.bindings
            ?.find((ele) => ele.bindingName === wsdlFields?.binding)
            ?.operations?.find((ele) => ele.operationName === operation);
          updateObj["REQUEST_ELEMENT_NAME"] =
            operationData?.fields?.request_element_name;
          updateObj["SOAP_ACTION"] = operationData?.fields?.soapAction;
          setRequestElement(operationData?.fields?.request_element_name);
          setSoapAction(operationData?.fields?.soapAction);
        }
        onInputChange(null, null, updateObj);
    }
    
    function handleServicePort(e) {
        const servicePort = e.target.value;
        setWsdlFields({ ...wsdlFields, servicePort: e.target.value });
    
        const updateObj = { [e.target.name]: e.target.value };
        if (servicePort === t("EMPTY_COMBO") || servicePort === t("SELECT")) {
          updateObj["CONNECTIONSTRING"] = null;
          setServiceEndpoint("");
        } else {
          const serviceData = wsdlCombo?.soapBindings?.bindings
            ?.find((ele) => ele.bindingName === wsdlFields?.binding)
            ?.servicePorts?.find((ele) => ele.name === servicePort);
          updateObj["CONNECTIONSTRING"] = serviceData?.service_endpoint;
          setServiceEndpoint(serviceData?.service_endpoint);
        }
        onInputChange(null, null, updateObj);
    }

    useEffect(() => {
        setOldUrl(connectionDetails?.WSDL_PATH || "");
        const cache = connectionDetails?.WSDL_CACHED || "";
        if (connectionDetails?.WSDL_PATH)
          getWsDlCombos(
            connectionDetails?.WSDL_PATH,
            cache,
            connectionDetails?.WSDL_PATH
          );
  
        setUseWSDL(connectionDetails?.USE_WSDL === "TRUE" ? true : false);
        setWsdlFields({
          wsdlPath: connectionDetails?.WSDL_PATH || "",
          binding: connectionDetails?.WSDL_BINDING || bindingOptions[0].value,
          operation:
            connectionDetails?.WSDL_BINDING_OPERATION ||
            operationOptions[0].value,
          servicePort:
            connectionDetails?.WSDL_BINDING_SERVICE ||
            servicePortOptions[0].value,
        });
        setUseWSDL(stringToBooleanConversion(connectionDetails?.USE_WSDL));
        setWsdlFile(connectionDetails?.FILE_PATH || '');
        setFilePath(connectionDetails?.FILE || '');
        if (direction === 'IN') setServiceEndpoint(connectionDetails?.CONNECTIONSTRING || `http://[SERVER_URL]/services/${account}/`);
        if (direction === 'OUT') setServiceEndpoint(connectionDetails?.CONNECTIONSTRING || '');
        setTargetNameSpace(connectionDetails?.TARGET_NAMESPACE || '');
        setRequestElement(connectionDetails?.REQUEST_ELEMENT_NAME || '');
        setSoapAction(connectionDetails?.SOAP_ACTION || '');
        setSoapPrefix(connectionDetails?.SOAP_PREFIX || 'tns');
        setAuthentication(connectionDetails?.AUTHENTICATE || 'NONE');
        setUsername(connectionDetails?.USERNAME || '');
        setPassword(connectionDetails?.PASSWORD || '');
        setRealm(connectionDetails?.REALM || '');
        setOutTime(connectionDetails?.TIMEOUT || (direction === 'OUT' ? 30 :''));
        setPrivateKey(connectionDetails?.KEY_ALIAS || '');
        setSslVersion(connectionDetails?.SSL_TYPE || connectionDetails?.SSL_VERSION || 'TLSv1');
        setSoapAsBody(stringToBooleanConversion(connectionDetails?.WRITE_SOAP_BODY));
        setHttpSession(stringToBooleanConversion(connectionDetails?.MAINTAIN_SESSION));
        setPolicy(connectionDetails?.POLICY || '');
        setKeyStore(connectionDetails?.KEY_STORE || '');
        setKeyStorePassword(connectionDetails?.KEY_STORE_PASSWORD || '');
        setKeyType(connectionDetails?.KEYSTORE_TYPE || '');
        setKeyStorePassword(connectionDetails?.PRIVATE_KEY_PASSWORD || '');
        setSyncResponse(stringToBooleanConversion(connectionDetails?.RECEIVE_SYNC_RESPONSE));
        setSoapBody(stringToBooleanConversion(connectionDetails?.SOAP_BODY_SEND_SOURCE));
        setCheckDataTransfer(stringToBooleanConversion(connectionDetails?.DISABLE_CHUNKED_DATA));
        setContent({ ...connectionDetails });
    }, [connectionDetails]);

    useEffect(() => {
        dispatch(api.endpoints.getSslVersion.initiate({ account })).then((res) => {
            if (res?.data?.current_state === 'SUCCESS') {
                setSslVersionsTypeOptions(res?.data?.data);
            }
            if (res?.data?.current_state === 'ERROR') {
                setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
            }
        })

        dispatch(api.endpoints.getPrivateKeys.initiate()).then((res) => {
            if (res?.data?.current_state === 'SUCCESS') {
                setPrivateKeys(res?.data?.data);
            }
            if (res?.data?.current_state === 'ERROR') {
                setShowAlert({ mssg: res?.data?.message, isOpen: true, type: 'error' });
            }
        })
    }, []);

    useEffect(() => {
        debouncedContentUpdate(content);
    }, [content]);


      useEffect(() => {
        if (Object.keys(wsdlCombo).length > 0) {
          setTargetNameSpace(wsdlCombo?.schemaInfo?.targetNamespace || "");
          const addObj = {};
    
          if (wsdlCombo?.schemaInfo?.targetNameSpace)
            addObj["TARGET_NAMESPACE"] =
              wsdlCombo?.schemaInfo?.targetNameSpace || "";
          if (wsdlCombo?.WSDL_CACHED)
            addObj["WSDL_CACHED"] = wsdlCombo?.WSDL_CACHED || "";
          if (wsdlCombo?.WSDL_POLICY_CACHED)
            addObj["WSDL_POLICY_CACHED"] = wsdlCombo?.WSDL_POLICY_CACHED || "";
    
          if(recallRefresh){
            addObj["WSDL_BINDING"] = t("SELECT");
            addObj["WSDL_BINDING_OPERATION"] = t("EMPTY_COMBO");
            addObj["WSDL_BINDING_SERVICE"] = t("EMPTY_COMBO");
            addObj["CONNECTIONSTRING"] = null;
            addObj["REQUEST_ELEMENT_NAME"] = null;
            addObj["SOAP_ACTION"] = null;
            setServiceEndpoint("");
            setRequestElement("");
            setSoapAction("");
            setRecallRefresh(false);
          }
    
          Object.keys(addObj).length && onInputChange(null, null, addObj);
          setBindingOptions(
            wsdlCombo?.soapBindings?.bindings?.length
              ? [
                  { text: t("SELECT"), value: t("SELECT") },
                  ...wsdlCombo?.soapBindings?.bindings?.map((item) => ({
                    text: item?.bindingName || "",
                    value: item?.bindingName || "",
                  })),
                ]
              : [{ text: t("EMPTY_COMBO"), value: t("EMPTY_COMBO") }]
          );
          setWsdlFields((prev) => ({
            ...prev,
            binding: recallRefresh ? t("SELECT") : (connectionDetails?.WSDL_BINDING || bindingOptions[0].value),
            operation: recallRefresh ? t("EMPTY_COMBO") : (connectionDetails?.WSDL_BINDING_OPERATION || operationOptions[0].value),
            servicePort: recallRefresh ? t("EMPTY_COMBO") : (connectionDetails?.WSDL_BINDING_SERVICE || servicePortOptions[0].value),
          }));
        }
      }, [wsdlCombo]);
    
      useEffect(() => {
        if (wsdlFields?.binding) {
          const selectedBinding =
            wsdlCombo?.soapBindings?.bindings?.find(
              (item) => item?.bindingName === wsdlFields?.binding
            ) || {};
          const operations = selectedBinding?.operations || [];
          const selectedSerPort = selectedBinding?.servicePorts || [];
    
          setOperationOptions([
              { 
                  text: operations.length ? t("SELECT") : t("EMPTY_COMBO"), 
                  value: operations.length ? t("SELECT") : t("EMPTY_COMBO") 
              },
              ...operations?.map((item) => ({
              text: item?.operationName || "",
              value: item?.operationName || "",
            })),
          ]);
    
          setServicePortOptions([
            { 
                text: selectedSerPort.length ? t("SELECT") : t("EMPTY_COMBO"), 
                value: selectedSerPort.length ? t("SELECT") : t("EMPTY_COMBO") 
            },
            ...selectedSerPort?.map((item) => ({
              text: item?.name || "",
              value: item?.name || "",
            })),
          ]);
        }
      }, [wsdlFields?.binding, wsdlCombo?.soapBindings?.bindings, t]);

    return (
        <Stack spacing="15px">
            <div className='flex flex-wrap'>
                <TPCheckbox
                    label={t("BTN_WS_USE_WSDL")}
                    checked={useWSDL || false}
                    name="USE_WSDL"
                    handleCheck={(checked) => {
                        setUseWSDL(checked);
          
                        if (checked)
                            onInputChange("USE_WSDL", checked ? "TRUE" : "FALSE");
                        else {
                          setWsdlFields({
                            wsdlPath: "",
                            binding: t("EMPTY_COMBO"),
                            operation: t("EMPTY_COMBO"),
                            servicePort: t("EMPTY_COMBO"),
                          });
          
                          setServiceEndpoint("");
                          setTargetNameSpace("");
                          setRequestElement("");
                          setSoapAction("");
                          setBindingOptions([{ text: t("EMPTY_COMBO"), value: t("EMPTY_COMBO") }]);
                          setOperationOptions([{ text: t("EMPTY_COMBO"), value: t("EMPTY_COMBO") }]);
                          setServicePortOptions([{ text: t("EMPTY_COMBO"), value: t("EMPTY_COMBO") }]);
          
                          onInputChange(null, null, {
                            USE_WSDL: null,
                            WSDL_PATH: null,
                            WSDL_BINDING: null,
                            WSDL_BINDING_OPERATION: null,
                            WSDL_BINDING_SERVICE: null,
                            CONNECTIONSTRING: null,
                            TARGET_NAMESPACE: null,
                            REQUEST_ELEMENT_NAME: null,
                            SOAP_ACTION: null,
                            ARGS: null,
                          });
                        }
                      }}
                />
                <Button
                    size="small"
                    disabled={!useWSDL}
                    variant="outlined"
                    onClick={() =>
                        getWsDlCombos(wsdlFields?.wsdlPath || "", "", oldUrl, true)
                    }>
                    {t("REFRESH")}
                </Button>
            </div>
            {
                useWSDL && <>
                    <div className="flex width-100">
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_WS_WSDL_PATH")}
                            className={"width-100"}
                            name={"WSDL_PATH"}
                            value={wsdlFields.wsdlPath || ""}
                            autoComplete="off"
                            onChange={(e) => {
                                setWsdlFields({ ...wsdlFields, wsdlPath: e.target.value });
                                onInputChange( [e.target.name], e.target.value || null );
                              }}
                        />
                        <input
                            style={{ display: "none" }}
                            type="file"
                            ref={fileBrowser}
                            value={filePath || ''}
                            name='FILE'
                            onChange={(e) => {
                                onInputChange('FILE_PATH', e.target.value);
                                setWsdlFile(e.target.value);
                            }}
                        />
                        <Button
                            variant="outlined"
                            size="small"
                            disableElevation
                            className="margin-left-4"
                            sx={{
                                width: "40px",
                                padding: "4px 8px",
                                minWidth: "40px",
                            }}
                            onClick={() => {
                                fileBrowser.current.click();
                            }}
                        >
                            <DriveFolderUploadIcon fontSize="small" />
                        </Button>
                    </div>
                    <FormControl variant="outlined" className="width-100" size="small">
                        <InputLabel id="bindingTypeDropdownLabel">
                            {t("LBL_WS_BINDING")}
                        </InputLabel>
                        <Select
                            className="width-100"
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name="WSDL_BINDING"
                            labelId="bindingTypeDropdownLabel"
                            label={t("LBL_WS_BINDING")}
                            id="bindingTypeDropdown"
                            value={bindingOptions.map((item) => item.value).includes(wsdlFields.binding) ? wsdlFields.binding : bindingOptions[0]?.value}
                            onChange={(e) => {
                                if (wsdlFields?.binding !== e.target.value) {
                                  setWsdlFields({
                                    ...wsdlFields,
                                    binding: e.target.value,
                                    operation: t("EMPTY_COMBO"),
                                    servicePort: t("EMPTY_COMBO"),
                                  });
                                  onInputChange(null, null, {
                                      [e.target.name]: e.target.value,
                                      WSDL_BINDING_OPERATION: t("EMPTY_COMBO"),
                                      WSDL_BINDING_SERVICE: t("EMPTY_COMBO"),
                                    });
                                }
                              }}
                        >
                            {bindingOptions.length !== 0 && (
                                bindingOptions.map((obj, key) => (
                                    <MenuItem key={key} value={obj.value}>
                                        {obj.text}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" className="width-100" size="small">
                        <InputLabel id="operationTypeDropdownLabel">
                            {t("LBL_WS_BINDING_OPERATION")}
                        </InputLabel>
                        <Select
                            className="width-100"
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name="WSDL_BINDING_OPERATION"
                            labelId="operationTypeDropdownLabel"
                            label={t("LBL_WS_BINDING_OPERATION")}
                            id="operationTypeDropdown"
                            value={operationOptions.map((item) => item.value).includes(wsdlFields.operation) ? wsdlFields.operation : operationOptions[0]?.value}
                            onChange={handleOperationChange}
                        >
                            {operationOptions.length !== 0 && (
                                operationOptions.map((obj, key) => (
                                    <MenuItem key={key} value={obj.value}>
                                        {obj.text}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" className="width-100" size="small">
                        <InputLabel id="servicePortTypeDropdownLabel">
                            {t("LBL_WS_BINDING_SERVICE")}
                        </InputLabel>
                        <Select
                            className="width-100"
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name="WSDL_BINDING_SERVICE"
                            labelId="servicePortTypeDropdownLabel"
                            label={t("LBL_WS_BINDING_SERVICE")}
                            id="servicePortTypeDropdown"
                            value={servicePortOptions.map((item) => item.value).includes(wsdlFields.servicePort) ? wsdlFields.servicePort : servicePortOptions[0]?.value}
                            onChange={handleServicePort}
                        >
                            {servicePortOptions.length !== 0 && (
                                servicePortOptions.map((obj, key) => (
                                    <MenuItem key={key} value={obj.value}>
                                        {obj.text}
                                    </MenuItem>
                                ))
                            )}
                        </Select>
                    </FormControl>
                </>
            }
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_SERVICE_ENDPOINT_URL")}
                    type="text"
                    value={serviceEndpoint}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setServiceEndpoint(e.target.value);
                    }}
                    className={"width-100"}
                    name={"CONNECTIONSTRING"}
                    autoComplete="off"
                />
            </FormControl>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_TARGET_NAMESPACE")}
                    type="text"
                    value={targetNameSpace}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setTargetNameSpace(e.target.value);
                    }}
                    className={"width-100"}
                    name={"TARGET_NAMESPACE"}
                    autoComplete="off"
                />
            </FormControl>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_REQUEST_ELEMENT")}
                    type="text"
                    value={requestElement || ''}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setRequestElement(e.target.value);
                    }}
                    className={"width-100"}
                    name={"REQUEST_ELEMENT_NAME"}
                    autoComplete="off"
                />
            </FormControl>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("SOAP_ACTION")}
                    type="text"
                    value={soapAction || ''}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setSoapAction(e.target.value);
                    }}
                    className={"width-100"}
                    name={"SOAP_ACTION"}
                    autoComplete="off"
                />
            </FormControl>
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_WS_SOAP_PREFIX")}
                    type="text"
                    value={soapPrefix || ''}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setSoapPrefix(e.target.value);
                    }}
                    className={"width-100"}
                    name={"SOAP_PREFIX"}
                    autoComplete="off"
                />
            </FormControl>
            <FormControl variant="outlined" className="width-100" size="small">
                <InputLabel id="authenticationTypeDropdownLabel">
                    {t("LBL_AUTHENTICATION")}
                </InputLabel>
                <Select
                    className={"width-100"}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: 300,
                            },
                        },
                    }}
                    name={"AUTHENTICATE"}
                    labelId="authenticationTypeDropdownLabel"
                    label={t("LBL_AUTHENTICATION")}
                    id="authenticationTypeDropdown"
                    value={authentication || ''}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setAuthentication(e.target.value);
                    }}
                >
                    {direction === 'IN' && authenticationWebServiceSourceTypeOptions.map((obj, key) => (
                        <MenuItem key={key} value={obj.value}>
                            {t(obj.text)?.toLocaleUpperCase()}
                        </MenuItem>
                    ))}
                    {direction === 'OUT' && authenticationWebServiceDestinationTypeOptions.map((obj, key) => (
                        <MenuItem key={key} value={obj.value}>
                            {t(obj.text)?.toLocaleUpperCase()}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {
                (authentication !== 'NONE') && <>
                    <FormControl className="width-100" size="small">
                        <TextField
                            variant="outlined"
                            size="small"
                            label={t("LBL_USERNAME")}
                            type="text"
                            value={username || ''}
                            onChange={(e) => {
                                onInputChange('USERNAME', e.target.value);
                                setUsername(e.target.value);
                            }}
                            className={"width-100"}
                            name={"USER_NAME"}
                            autoComplete="off"
                        />
                    </FormControl>

                    <SmartPasswordField
                        variant="outlined"
                        size="small"
                        label={t("LBL_WS_PASSWORD")}
                        value={password || ''}
                        onChange={(e) => {
                            onInputChange('PASSWORD', e.target.value);
                            setPassword(e.target.value);
                        }}
                        className={"width-100"}
                        name={"PASS_WORD"}
                        autoComplete="off"
                    />
                    {
                        authentication === 'KERBEROS' && <>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={t("LBL_REALM")}
                                    type="text"
                                    value={realm || ''}
                                    onChange={(e) => {
                                        onInputChange(e.target.name, e.target.value);
                                        setRealm(e.target.value);
                                    }}
                                    className={"width-100"}
                                    name={"REALM"}
                                    autoComplete="off"
                                />
                            </FormControl>
                        </>
                    }
                    {authentication === 'WS_SECURITY' && <>
                        <FormControl className="width-100" size="small">
                            <TextField
                                variant="outlined"
                                size="small"
                                label={t("LBL_POLICY")}
                                type="text"
                                value={policy || ''}
                                onChange={(e) => {
                                    onInputChange(e.target.name, e.target.value);
                                    setPolicy(e.target.value);
                                }}
                                className={"width-100"}
                                name={"POLICY"}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormControl className="width-100" size="small">
                            <TextField
                                variant="outlined"
                                size="small"
                                label={t("LBL_KEYSTORE")}
                                type="text"
                                value={keyStore || ''}
                                onChange={(e) => {
                                    onInputChange(e.target.name, e.target.value);
                                    setKeyStore(e.target.value);
                                }}
                                className={"width-100"}
                                name={"KEY_STORE"}
                                autoComplete="off"
                            />
                        </FormControl>
                        <SmartPasswordField
                            variant="outlined"
                            size="small"
                            label={t("LBL_KEYSTORE_PASSWORD")}
                            value={keyStorePassword || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setKeyStorePassword(e.target.value);
                            }}
                            className={"width-100"}
                            name={"KEY_STORE_PASSWORD"}
                            autoComplete="off"
                        />
                        <FormControl className="width-100" size="small">
                            <TextField
                                variant="outlined"
                                size="small"
                                label={t("LBL_KEYSTORE_TYPE")}
                                type="text"
                                value={keyType || ''}
                                onChange={(e) => {
                                    onInputChange(e.target.name, e.target.value);
                                    setKeyType(e.target.value);
                                }}
                                className={"width-100"}
                                name={"KEYSTORE_TYPE"}
                                autoComplete="off"
                            />
                        </FormControl>
                        <SmartPasswordField
                            variant="outlined"
                            size="small"
                            label={t("LBL_PRIVATE_KEY_PASSWORD")}
                            value={privateKeyPassword || ''}
                            onChange={(e) => {
                                onInputChange(e.target.name, e.target.value);
                                setPrivateKeyPassword(e.target.value);
                            }}
                            className={"width-100"}
                            name={"PRIVATE_KEY_PASSWORD"}
                            autoComplete="off"
                        />
                        <Autocomplete
                            disablePortal
                            options={userCertAliasTypes}
                            value={userCert}
                            sx={{ maxHeight: 300 }}
                            onChange={(e, value) => {
                                onInputChange('USER_CERT_ALIAS', value);
                                setUserCert(value)
                            }}
                            renderInput={(params) => <TextField
                                {...params}
                                label={t("LBL_USER_CERT_ALIAS")}
                                value={privateKey}
                                onChange={(event, value) => {
                                    onInputChange('USER_CERT_ALIAS', value);
                                    setUserCert(value)
                                }}
                                variant="outlined"
                                size="small"
                                name={'USER_CERT_ALIAS'}
                                autoComplete="off"
                            />
                            }
                        />
                    </>
                    }
                </>
            }
            <FormControl className="width-100" size="small">
                <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_TIMEOUT")}
                    type="text"
                    value={outTime}
                    onChange={(e) => {
                        const inputValue = e.target.value;
                        const numericValue = inputValue.replace(/\D/g, '');
                        if (numericValue.length <= 9) {
                            setOutTime(numericValue);
                            onInputChange(e.target.name, numericValue);
                        }
                    }}
                    className={"width-100"}
                    name={"TIMEOUT"}
                    autoComplete="off"
                />
            </FormControl>
            <Autocomplete
                disablePortal
                options={privateKeys}
                value={privateKey}
                sx={{ maxHeight: 300 }}
                onChange={(e, value) => {
                    onInputChange('KEY_ALIAS', value);
                    setPrivateKey(value)
                }}
                renderInput={(params) => <TextField
                    {...params}
                    label={t("KEY_ALIAS")}
                    value={privateKey}
                    onChange={(event, value) => {
                        onInputChange('KEY_ALIAS', event.target.value);
                        setPrivateKey(event.target.value)
                    }}
                    variant="outlined"
                    size="small"
                    name={'KEY_ALIAS'}
                    autoComplete="off"
                />
                }
            />
            <FormControl variant="outlined" className="width-100" size="small">
                <InputLabel id="sslTypeDropdownLabel">
                    {t("LBL_SSL_TYPE")}
                </InputLabel>
                <Select
                    className={"width-100"}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                maxHeight: 300,
                            },
                        },
                    }}
                    name={"SSL_TYPE"}
                    labelId="sslTypeDropdownLabel"
                    label={t("LBL_SSL_TYPE")}
                    id="sslTypeDropdown"
                    value={sslVersion || ''}
                    onChange={(e) => {
                        onInputChange(e.target.name, e.target.value);
                        setSslVersion(e.target.value);
                    }}
                >
                    {
                        sslVersionsTypeOptions.map((obj, key) => (
                            <MenuItem key={key} value={obj}>
                                {obj}
                            </MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
            <div className='flex flex-column'>
                <TPCheckbox
                    label={t("BTN_WS_SOAP_BODY_AS_RESULT")}
                    checked={soapAsBody}
                    handleCheck={(checked) => {
                        onInputChange('WRITE_SOAP_BODY', stringifyJSONAttributes(checked));
                        setSoapAsBody(checked);
                    }}
                />
                <TPCheckbox
                    label={t("MAINTAIN_SESSION")}
                    checked={httpSession}
                    handleCheck={(checked) => {
                        onInputChange('MAINTAIN_SESSION', stringifyJSONAttributes(checked));
                        setHttpSession(checked);
                    }}
                />
                {direction === 'OUT' && <>
                    <TPCheckbox
                        label={t("BTN_RECEIVE_SYNC_RESPONSE")}
                        checked={syncResponse}
                        handleCheck={(checked) => {
                            onInputChange('RECEIVE_SYNC_RESPONSE', stringifyJSONAttributes(checked));
                            setSyncResponse(checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_WS_SOAP_BODY_SEND_SOURCE")}
                        checked={soapBody}
                        handleCheck={(checked) => {
                            onInputChange('SOAP_BODY_SEND_SOURCE', stringifyJSONAttributes(checked));
                            setSoapBody(checked);
                        }}
                    />
                    <TPCheckbox
                        label={t("BTN_WS_DISABLE_CHUNKED_DATA")}
                        checked={checkDataTransfer}
                        handleCheck={(checked) => {
                            onInputChange('DISABLE_CHUNKED_DATA', stringifyJSONAttributes(checked));
                            setCheckDataTransfer(checked);
                        }}
                    />
                </>
                }
            </div>
            <Snackbar open={showAlert.isOpen} onClose={() => handleAlertClose()}>
                <Alert
                    onClose={() => handleAlertClose()}
                    severity={showAlert.type}
                    variant="filled"
                    sx={{ width: "100%" }}>
                    {showAlert.mssg}
                </Alert>
            </Snackbar>
            {showErrorModal && (
              <ErrorModal
                errorModal={showErrorModal}
                setErrorModal={setShowErrorModal}
                errorMessage={`${t("BOX_WSDL_PROCESS_ERROR")}: ${errorMessage}`}
                errorType={t("ERROR")}
                OkHandler={() => {
                  setShowErrorModal(false);
                  setErrorMessage("");
                }}
              />
            )}
        </Stack>
    )
}

export default WebService